import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { spacing } from 'ui/theme';

export const SkeletonRow = styled.div`
  display: flex;
`;

export const ContentDivider = styled(Divider)`
  margin: ${`${spacing.base} 0`};
`;

export const ColumnTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;
